<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <label class="generalLabel" for="vendorCheck">Se va a aceptar la revisión del contrato, pulse "Confirmar" para
      continuar.</label>
    <button class="btn btn-primary generalPrimaryButton float-right" data-dismiss="modal" aria-label="Close" @click="accept()">Confirmar</button>
  </Modal>
</template>

<script>

import Modal from '../../../Shared/Modal.vue';
import axios from 'axios';
export default {
  name: 'AcceptContractDetail',
  props: [
    'id',
    'modalTitle',
    'class',
    'contractId',
  ],
  data() {
    return {
      classes: this.class,
    }
  },
  components: {
    Modal,
  },
  methods: {
    accept(){
      let bodyToSend = {
        contractId: this.contractId,
        status: 'ACCEPTED',
        blacklist: false
      }
      axios.put(`/contract/validation/update-status`, bodyToSend)
        .then(() => {
          
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>

